import { useEffect, useState } from "react";
import {
  isEmbedded as isEmbeddedComponent,
  isExternalEmbed,
} from "@shared/utils/window/window-utils";

/**
 * Returns properties that keep track of the page content's embedded status,
 * Whether the page is embedded on the Showpass site or another site altogether.
 * Used for widgets like assigned seating, event calendar, etc.
 */
export const useEmbeddedComponent = (): {
  isEmbedded: boolean;
  isExternalEmbedded: boolean;
} => {
  const [isEmbedded, setIsEmbedded] = useState(false);
  const [isExternalEmbedded, setIsExternalEmbedded] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      if (isEmbeddedComponent()) {
        // True if the content is embedded in any iframe (even on the Showpass site).
        setIsEmbedded(true);

        if (isExternalEmbed()) {
          // True if the content is embedded in an iframe on another site.
          setIsExternalEmbedded(true);
        }
      }
    }
  }, [isEmbeddedComponent, isExternalEmbed]);

  return { isEmbedded, isExternalEmbedded };
};
